
{
  "options": {
    "logo-left": "Left",
    "logo-center": "Center"
  },
  "label": "Logo Position"
}
